import clsx from "clsx";
import React, { FC, HTMLAttributes, ReactElement, ReactNode } from "react";
import css from "./ComponentOverlay.module.css";
import { ComponentOverlayContext } from "../hooks";

// Define the interface for the component props
interface ReactWithChildren extends HTMLAttributes<HTMLDivElement> {
	/** children elements for overlay to pass to the div element */
	children: ReactNode;

	/** overlay should be behind / in front of the children */
	isOverlayBehindChildren?: boolean;

	/** optional overlay element to be rendered on top of, or behind the children, if none supplied, default overlay will be used */
	overlay?: ReactElement;
}

export const ComponentOverlay: FC<ReactWithChildren> = ({ children, isOverlayBehindChildren, overlay, ...divProps }) => {
	return (
		<ComponentOverlayContext.Provider value>
			<div
				{...divProps}
				className={clsx(
					css.componentOverlayWrapper,
					isOverlayBehindChildren && css.zIndexBelowChildren,
					divProps.className,
				)}
			>
				{/* render custom overlay if provided, otherwise render default overlay */}
				{overlay ? overlay : <div className={css.overlay} /> }
				{children}
				{/* Render an internal overlay if the main overlay is behind the children */}
				{isOverlayBehindChildren ? <div className={css.internalOverlay} /> : null}
			</div>
		</ComponentOverlayContext.Provider>
	);
};
